import { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { toast } from "sonner";
import { FORMATS } from "../data/menu";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PUT_IN = [
  ["Franchise fee (5 yrs)", "₹3 L"],
  ["Khoka setup, kit & deposit", "₹8–12 L"],
  ["Royalty on net sales", "5%"],
  ["Brand fund", "2%"],
  ["Your time", "FULL DIL"],
];

const YOU_GET = [
  ["Site scouting & flat-pack fit-out", "DONE WITH YOU"],
  ["14 days at the mother stall", "TRAINING"],
  ["Chutneys, masalas & vada mix", "CENTRAL SUPPLY"],
  ["Opening carnival + aggregator launch", "MARKETING"],
  ["Monthly audits & new menu drops", "OPS SUPPORT"],
];

const TIMELINE = [
  ["DAY 0", "SIGN & SITE LOCK"],
  ["DAY 30", "KHOKA STANDS"],
  ["DAY 38", "CREW CERTIFIED"],
  ["DAY 45", "GARMA GARAM DAY"],
];

const inputCls =
  "w-full rounded-xl border-4 border-kadak bg-pav px-4 py-3 font-poppins text-sm text-kadak placeholder:text-kadak/40 focus:outline-none focus:ring-4 focus:ring-taxi/60";

export const Franchise = () => {
  const [form, setForm] = useState({ name: "", phone: "", email: "", city: "", format: "khoka", message: "" });
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/franchise`, form);
      toast.success("Ho gaya! Your interest is in the queue — we'll call you, garma-garam.");
      setForm({ name: "", phone: "", email: "", city: "", format: "khoka", message: "" });
    } catch (err) {
      toast.error("Arre, something dropped. Check your details and try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section id="franchise" data-testid="franchise-section" className="scroll-mt-16 bg-kadak py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <p className="font-bungee text-xs tracking-[0.35em] text-gulabi sm:text-sm">THE FRANCHISE</p>
        <h2 className="mt-4 max-w-4xl font-shrikhand text-4xl leading-tight text-pav sm:text-5xl lg:text-6xl">
          You bring the hustle. <span className="text-taxi">We bring the rest.</span>
        </h2>

        <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-3">
          {FORMATS.map((f, i) => (
            <motion.div
              key={f.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.4, delay: i * 0.1 }}
              className={`relative rounded-3xl border-4 p-7 ${
                f.flagship ? "border-taxi bg-[#2B2114] sticker-shadow-taxi" : "border-pav/30 bg-[#2B2114]"
              }`}
            >
              {f.flagship && (
                <span className="absolute -top-4 right-6 rounded-full border-2 border-kadak bg-gulabi px-4 py-1 font-bungee text-xs text-kadak">
                  FLAGSHIP
                </span>
              )}
              <h3 className="font-shrikhand text-3xl text-taxi">{f.name}</h3>
              <p className="mt-1 font-bungee text-xs tracking-widest text-gulabi">{f.type}</p>
              <div className="mt-5 space-y-0 border-t-2 border-dashed border-pav/20 text-sm">
                {[
                  ["Setup", f.setup],
                  ["Crew", f.crew],
                  ["Where", f.where],
                  ["Menu", f.menu],
                ].map(([k, v]) => (
                  <div key={k} className="flex justify-between gap-3 border-b-2 border-dashed border-pav/20 py-2.5">
                    <span className="text-pav/60">{k}</span>
                    <span className="text-right font-anton uppercase text-pav">{v}</span>
                  </div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-14 grid grid-cols-1 gap-8 lg:grid-cols-2">
          <div className="rounded-3xl border-4 border-mirchi bg-[#33150F] p-7">
            <h3 className="font-bungee text-sm tracking-[0.3em] text-mirchi">WHAT YOU PUT IN</h3>
            <div className="mt-4 divide-y divide-dashed divide-pav/15">
              {PUT_IN.map(([k, v]) => (
                <div key={k} className="flex justify-between py-3 text-sm">
                  <span className="text-pav/80">{k}</span>
                  <span className="font-anton text-taxi">{v}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="rounded-3xl border-4 border-chutney bg-[#0F2A1B] p-7">
            <h3 className="font-bungee text-sm tracking-[0.3em] text-chutney">WHAT YOU GET</h3>
            <div className="mt-4 divide-y divide-dashed divide-pav/15">
              {YOU_GET.map(([k, v]) => (
                <div key={k} className="flex justify-between gap-3 py-3 text-sm">
                  <span className="text-pav/80">{k}</span>
                  <span className="text-right font-anton text-taxi">{v}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12">
          <p className="font-bungee text-xs tracking-[0.3em] text-gulabi">SIGNATURE-TO-SIZZLE IN 45 DAYS</p>
          <div className="mt-5 grid grid-cols-2 gap-6 md:grid-cols-4">
            {TIMELINE.map(([d, t], i) => (
              <div key={d} className="relative border-t-4 border-dashed border-taxi/60 pt-4">
                <span className="absolute -top-3 left-0 h-5 w-5 rounded-full border-4 border-taxi bg-kadak" />
                <p className="font-bungee text-xs text-gulabi">{d}</p>
                <p className="mt-1 font-anton text-sm uppercase text-pav sm:text-base">{t}</p>
                {i === TIMELINE.length - 1 && <p className="mt-1 font-shrikhand text-lg text-taxi"></p>}
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 items-start gap-10 lg:grid-cols-[1fr_1.1fr]">
          <div>
            <h3 className="font-shrikhand text-3xl text-pav sm:text-4xl">Franchise interest — abhi khula hai.</h3>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-pav/70">
              Spots for the first batch are limited and Nashik & Pune are already heating up. Drop your
              details — real person, real call back. No spam, only masala.
            </p>
            <p className="mt-6 inline-block -rotate-1 border-y-4 border-kadak bg-taxi px-4 py-2 font-bungee text-xs tracking-widest text-kadak">
              AAJ KA SPECIAL: SAB KUCH.
            </p>
          </div>
          <form
            onSubmit={submit}
            data-testid="franchise-form"
            className="rounded-3xl border-4 border-kadak bg-pav p-6 sticker-shadow-taxi sm:p-8"
          >
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              <div>
                <label className="mb-1.5 block font-anton text-xs uppercase tracking-wide" htmlFor="fr-name">Your name</label>
                <input id="fr-name" data-testid="franchise-name-input" required minLength={2} className={inputCls} placeholder="Sachin T." value={form.name} onChange={set("name")} />
              </div>
              <div>
                <label className="mb-1.5 block font-anton text-xs uppercase tracking-wide" htmlFor="fr-phone">Phone</label>
                <input id="fr-phone" data-testid="franchise-phone-input" required minLength={8} className={inputCls} placeholder="98XXX XXXXX" value={form.phone} onChange={set("phone")} />
              </div>
              <div>
                <label className="mb-1.5 block font-anton text-xs uppercase tracking-wide" htmlFor="fr-email">Email</label>
                <input id="fr-email" data-testid="franchise-email-input" required type="email" className={inputCls} placeholder="tum@example.com" value={form.email} onChange={set("email")} />
              </div>
              <div>
                <label className="mb-1.5 block font-anton text-xs uppercase tracking-wide" htmlFor="fr-city">City</label>
                <input id="fr-city" data-testid="franchise-city-input" required minLength={2} className={inputCls} placeholder="Nashik / Pune / ..." value={form.city} onChange={set("city")} />
              </div>
              <div className="sm:col-span-2">
                <label className="mb-1.5 block font-anton text-xs uppercase tracking-wide" htmlFor="fr-format">Which format?</label>
                <select id="fr-format" data-testid="franchise-format-select" className={inputCls} value={form.format} onChange={set("format")}>
                  <option value="gaadi">The Gaadi — Cart, ₹3.5–5 L</option>
                  <option value="khoka">The Khoka — Kiosk, ₹8–12 L (Flagship)</option>
                  <option value="adda">The Adda — Store, ₹22–30 L</option>
                  <option value="not_sure">Not sure yet — convince me</option>
                </select>
              </div>
              <div className="sm:col-span-2">
                <label className="mb-1.5 block font-anton text-xs uppercase tracking-wide" htmlFor="fr-message">Anything else? (optional)</label>
                <textarea id="fr-message" data-testid="franchise-message-input" rows={3} maxLength={1000} className={inputCls} placeholder="Site in mind? Budget? Timing? Tell us." value={form.message} onChange={set("message")} />
              </div>
            </div>
            <button
              type="submit"
              data-testid="franchise-submit-btn"
              disabled={busy}
              className="mt-6 w-full rounded-full border-4 border-kadak bg-mirchi px-7 py-3.5 font-bungee text-sm text-pav sticker-shadow-sm transition-transform duration-150 hover:-translate-y-1 hover:-translate-x-1 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {busy ? "FRYING..." : "COUNT ME IN →"}
            </button>
            <p className="mt-3 text-center text-xs text-kadak/50">All numbers illustrative pending pilot data.</p>
          </form>
        </div>
      </div>
    </section>
  );
};
